
import {otmsHttp} from '@/utils/http/index.js'

export default {
    /**
     * https://yapi.ops.yunlizhi.cn/project/130/interface/api/701
     */  
    getDictionary(data) {
        return otmsHttp.post('/base_plus/data_dictionary/list',data)
    }
}
